import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-review',
    templateUrl: './common-review.component.html',
    styleUrls: ['./common-review.component.scss'],
    standalone: false
})
export class CommonReviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
